export default __webpack_public_path__ + "static/touch-icon-98b8302c6d24a99faf7182af623ad01e.png";